import { z } from "zod";

/**
 * Client-side field validation for the onboarding wizard's interactive steps. The SERVER is
 * authoritative (the tenancy/floor domain enforces the real rules + a 422 maps its `fieldErrors`
 * back onto these same fields); these schemas give immediate feedback before the round-trip.
 */

export function profileFormSchema(t: (key: string) => string) {
  return z.object({
    displayName: z.string().trim().min(1, t("onboarding.error.displayName")),
    // Legal name (raison sociale) is NOT collected during onboarding — it isn't needed to create or run
    // a venue (nullable server-side) and is gathered later at billing time. Keeps signup friction low.
    category: z.string().min(1),
    // National FR input is accepted; the server normalizes to E.164 via PhoneNormalizerPort (§B.3).
    contactPhone: z.string().trim().optional(),
  });
}

export type ProfileFormValues = z.infer<ReturnType<typeof profileFormSchema>>;

export function capacityFormSchema(t: (key: string) => string) {
  return z.object({
    totalCovers: z.coerce.number().int().min(0, t("onboarding.error.totalCovers")),
  });
}

export type CapacityFormValues = z.infer<ReturnType<typeof capacityFormSchema>>;
